document.addEventListener('DOMContentLoaded', () => {
	const addToCartBanner = document.getElementById('added-to-cart-msg');

    if (addToCartBanner) {
        const closeButton = addToCartBanner.querySelector('.close');

        if (closeButton) {
            closeButton.addEventListener('click', () => {
                addToCartBanner.classList.add('hide'); // Correct logic to hide the banner
            });
        }
    }
});


jQuery(document).ready(function ($) {
	if (document.body.classList.contains('single-product')) {
		var $variationForm = $('.variations_form');

		if (window.location.href.indexOf('#review-invullen') !== -1) {
			$('#commentform').css('display', 'flex')
		}

		$('.single_add_to_cart_button').removeAttr('disabled')

		$('form.variations_form').on('found_variation', function(event, variation) {
			var $waitlistForm = $('.oos-form-container');
	
			// Update the price area with the variation's price
			if (variation.display_price) {
				var price_html = variation.price_html; // WooCommerce provides this
				if (variation.price_html) {
					$('.product .price-wrapper p.price').html(price_html);
				}
			}

			// Update the stock status
			var stock_status = variation.is_in_stock;
			if(stock_status) {
				const inStockLabel = $('.product .price-wrapper .stock-status').data('label-in-stock') || 'Op voorraad';
				$('.product .price-wrapper .stock-status').addClass('in-stock').removeClass('out-of-stock').html(inStockLabel);
				$('.single_variation_wrap fieldset').show();
				$waitlistForm.hide();
			} else {
				const outOfStockLabel = $('.product .price-wrapper .stock-status').data('label-out-of-stock') || 'Niet op voorraad';
				$('.product .price-wrapper .stock-status').addClass('out-of-stock').removeClass('in-stock').html(outOfStockLabel);
				$('.single_variation_wrap fieldset').hide();
				$waitlistForm.show();
			}

			// Update fieldset
			const display_price = variation.display_price;

			$('.label-price.calc').each(function() {
				let percentage = parseFloat($(this).data('percentage'));
				$(this).html((display_price * (1 - (percentage / 100))).toFixed(2));
			});
			$('.label-price:not(.calc)').html(display_price);

			// Get the sticky form
			let $stickyForm = $('.sticky-footer form');

			// Update the variation ID in the sticky form
			$stickyForm.find('input[name="variation_id"]').val(variation.variation_id);
	
			// Update attributes for the sticky form
			$.each(variation.attributes, function (name, value) {
				let attributeName = name.replace('attribute_', '');
				$stickyForm.find(`[name="attribute_${attributeName}"]`).val(value);
			});
	
			// Enable the button (if previously disabled)
			$stickyForm.find('.single_add_to_cart_button').prop('disabled', false);
		});	

		var $waitlistForm = $('.oos-form-container');

		$variationForm.on('reset_data', function () {
			$waitlistForm.hide();
		});

		// Get the value of the checked input in the fieldset
		$('.pdp__top__right fieldset input').on('change', function() {
			const checkedInputValue = $(this).val();
			const quantityInput = $('.quantity input[name="quantity"].qty');
			quantityInput.each(function() {
				$(this).val(checkedInputValue);
			});
		});

		// Add to cart
		$('form.cart:not(.bundle_form)').on('submit', function (e) {
			e.preventDefault()

			const form = $(this)
			const variation_id = form.find('input[name="variation_id"]').val() || ''
			const quantity = form.find('input[name="quantity"]').val() || 1
			const attributes = form.find('input[name^="attribute_"]').length ? form.serialize() : ''
			const productType = variation_id ? 'variable' : 'simple'

			let product_id
			if (productType === 'variable') {
				product_id = form.find('input[name="add-to-cart"]').val()
			} else {
				product_id = form.find('button[name="add-to-cart"]').val()
			}

			if (!product_id) {
				alert('Product ID is missing.')
				return
			}

			const data = {
				action: 'ajax_add_to_cart',
				product_id: product_id,
				quantity: quantity
			}

			if (productType === 'variable') {
				data.variation_id = variation_id
				data.attributes = attributes
			}

			const addToCartBtn = form.find('button[type="submit"]')

			if (addToCartBtn) {
				addToCartBtn.addClass('loading')
			}

			const addToCartBanner = document.getElementById('added-to-cart-msg')

			$.post(js_data.ajax_url, data, function (response) {
				addToCartBtn.removeClass('loading').addClass('added')

				if (addToCartBanner) {
					addToCartBanner.classList.remove('hide')
				}

				if (response.error) {
					$('<p class="failed-to-add-to-cart">' + response.error_message + '</p>').insertAfter('form.cart')

					setTimeout(function () {
						$('.failed-to-add-to-cart').remove()
						addToCartBtn.classList.remove('added')
					}, 6000)
				} else {
					$(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, addToCartBtn])

					setTimeout(function () {
						addToCartBtn.removeClass('added').find('.add-now').text(addToCartBtn.attr('data-add'))

						if (addToCartBanner) {
							addToCartBanner.classList.add('hide')
						}
					}, 6000)
				}
			}).fail(function (jqXHR, textStatus, errorThrown) {
				console.log('Error:', errorThrown)
				addToCartBtn.removeClass('loading').find('.add-now').text(addToCartBtn.attr('data-add'))
			})
		})

		$(document.body).on('added_to_cart', function (event, fragments, cart_hash, addToCartBtn) {
			const viewCartLink = $('.added_to_cart');
			const formCart = $('form.cart');

			if (viewCartLink.length) {
				viewCartLink.removeClass('hidden');
				viewCartLink.insertBefore(formCart);
			}
		
			setTimeout(function () {
				viewCartLink.addClass('hidden');
			}, 6000);
		});
	}
})